import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import persistStore from 'redux-persist/es/persistStore';

import { store } from '@/store';

import App from './App';

import './index.scss';

const helmetContext = {};
const IndexPage = () => {
  persistStore(store);

  return (
    <React.StrictMode>
      <Provider store={store}>
        <HelmetProvider context={helmetContext}>
          <App />
        </HelmetProvider>
      </Provider>
    </React.StrictMode>
  );
};

createRoot(document.getElementById('root')).render(<IndexPage />);
